import React, { useState } from "react";
import { sendEmail } from "./email.js";
import styled from 'styled-components';
import './Mailer.css'
import WhatsAppForm from './WhatsAppForm'

const MailerContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormTitle = styled.h4`
  text-align: center;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const FormTextarea = styled.textarea`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const FormButton = styled.button`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  background-color: black;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const ContactoContainer = styled.div`
  text-align: center;
  margin-top: 20px;
  color:gray;
  text-decoration:none
`;

const ContactoTitle = styled.h5`
  margin-bottom: 8px;
`;

const ContactoInfo = styled.h5`
  margin-bottom: 7px;
 
`;

const ContactoLink = styled.a`
  color: black;
  text-decoration: none;
  font-size:20px
`;

function Mailer() {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
  });

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendEmail(formData);
    setFormData({ name: "", number: "", email: "", message: "" });
  };

  return (
    <MailerContainer>
      <FormContainer onSubmit={handleSubmit}>
        <FormTitle>DEJANOS TU MENSAJE</FormTitle>
        <FormGroup>
          <FormInput
            type="text"
            name="name"
            placeholder="Nombre"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <FormInput
            type="tel"
            name="number"
            placeholder="Teléfono"
            value={formData.number}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <FormInput
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <FormTextarea
            name="message"
            placeholder="Mensaje"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormButton type="submit">Enviar</FormButton>
      </FormContainer>

      <ContactoContainer>
        <ContactoTitle>Asesoramiento y</ContactoTitle>
        <ContactoInfo>Presupuesto sin cargo</ContactoInfo>

        
        <p><i className="fa fa-phone fa-rotate-90"></i> <ContactoLink href="tel:+5401125528283">01125528283</ContactoLink></p>
        <p> <ContactoLink href="mailto/disenosdanyweb@gmail.com">disenosdanyweb@gmail.com</ContactoLink></p>
      </ContactoContainer>
      <WhatsAppForm />
    </MailerContainer>
    
  );
}

export default Mailer;
